import script from "./Gender.vue?vue&type=script&setup=true&lang=js"
export * from "./Gender.vue?vue&type=script&setup=true&lang=js"

import "./Gender.vue?vue&type=style&index=0&id=7bef31d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bef31d3"]])

export default __exports__